export enum FeatureFlagStrategyEnum {
    TOGGLE = "TOGGLE",
}

export enum FeatureFlagStrategySelectorEnum {
    ALL = "ALL",
    NONE = "NONE",
    INCLUDE = "INCLUDE",
    EXCLUDE = "EXCLUDE",
}

export interface FeatureFlagStrategyConfig {
    enabled: boolean;
}

export interface FeatureFlagStrategy {
    id?: string;
    strategy: FeatureFlagStrategyEnum;
    config: FeatureFlagStrategyConfig;
    selector: FeatureFlagStrategySelectorEnum;
    companyIds: string[];
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
}
